export const LEGAL_TEXT = "Innova-Sign est une division d'Innova-Solution. Tous les droits de propriété intellectuelle et autres droits sont la propriété exclusive d'Innova-Solution.";

export function LegalNotice({ className = "" }: { className?: string }) {
  return (
    <p data-testid="legal-notice" className={`text-[11px] leading-relaxed text-slate-500 ${className}`}>
      © 2026 Innova-Solution. {LEGAL_TEXT}{" "}
      <a href="https://innova-solution.ca" target="_blank" rel="noreferrer" data-testid="legal-notice-link" className="text-orange-400 hover:text-orange-300">innova-solution.ca</a>
    </p>
  );
}
